<template>
	<el-dialog
		custom-class="preview_dialog"
		title=""
		:append-to-body="true"
		:visible="visible"
		v-bind="$attrs"
		@close="$emit('update:visible', false)"
		v-loading="loading"
		:element-loading-text="$t('message.正在导出PDF')"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"
	>
		<div class="preview_wrapper" id="preview_wrapper" :style="{height: '100%',backgroundImage:`url(${pdfBg})`  }">
			<header class="preview_header">
				<img :src="logo" alt="">
				<div class="preview_header_text">
					<h1>{{ title }}</h1>
					<p v-if="date">{{date}}</p>
					<slot name="header_info" v-else>
					</slot>
				</div>
				<slot name="action">
					<span class="Action_block preview_header_icon" @click="handlePrintPdf">
						<cl-svg-icon iconClass="export_pdf" width="24" ></cl-svg-icon>
					</span>
				</slot>
			</header>

			<main class="preview_main">
				<slot></slot>
			</main>
		</div>
	</el-dialog>
</template>

<script>
	export default {
    	name: 'cl-print-dialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: ''
			},
			date: {
				type: String,
			}
		},

		data() {
			return {
				openStatus: false,
				loading: false,
				base64: '',
				base64Arr: [], // 截取的base64结果
				pageHeight: 8000,  // 截取单页高度
				pdfBg: this.$UIConfig.exportPdfBg,   // pdf背景图
            	logo: this.$UIConfig.logo,  // logo
			}
		},


		methods: {
			async handlePrintPdf() {
				this.openStatus = true
				this.loading = true
				await this.$nextTick()
				const initCropY = document.querySelector('.preview_dialog').offsetTop // 父级距离window顶部的距离，这里是el-dialog的margin-top:15vh;
				const dom = document.getElementById('preview_wrapper') // 内容容器
				const offsetWidth = dom.offsetWidth // 内容宽度
				const offsetHeight = dom.offsetHeight // 内容高度
				const pageHeight = this.pageHeight // 截取单页高度
				const count = Math.ceil(offsetHeight / pageHeight) // 需要截取几次
				let cropDomHeight = pageHeight // 每一次截取的高度，比如offsetHeight为16100，前两次截取都是8000，最后一次截的是100。
				let cropY = 0 // 需要截取的高度
				this.base64Arr = [] // 截取的base64结果

				for (let i=1; i<=count; i++) {
					if (i === count) {
						cropDomHeight = offsetHeight % pageHeight // 最后一次截取的高度
					}

					let res = await this.domToBase64('#preview_wrapper', cropDomHeight, cropY)
					this.base64Arr.push({
						base64: res, // 本次截取的图片
						height: cropDomHeight, // 本次截取图片的高度
					})

					cropY += pageHeight // 在截取后，累加截取高度。
				}

				this.mergeImgs(this.base64Arr, offsetWidth, offsetHeight).then(res  => {
					this.openStatus = false
					this.base64ToPdf(res, this.title)
					setTimeout(() => {
						this.loading = false
					}, 1000)
				})
			},

			// 合并多个base64为1个base64
			mergeImgs(list, canvasWidth, canvasHeight) {
				return new Promise((resolve, reject) => {
					var canvas = document.createElement('canvas')
					canvas.width = canvasWidth
					canvas.height = canvasHeight
					const context = canvas.getContext('2d')
					list.map((item, index) => {
						const img = new Image()
						img.src = item.base64
						img.crossOrigin = 'Anonymous' // 跨域
						img.onload = () => {
							context.drawImage(img, 0, this.pageHeight * index, canvasWidth, item.height) // 向canvas内添加图片
							if (index + 1 === list.length) {
								const base64 = canvas.toDataURL('image/png', 1)
								resolve(base64)
							}
						}
					})
				})
			},
		}

	}
</script>

<style lang="scss">
.preview_dialog {
	// margin-top: 0;
	// height: 100%;
	max-height: 91% !important;
	.el-dialog__header{
		display: none;
	}
	.el-dialog__body {
		padding: 0 !important;
	}

	.preview_wrapper {
		display: flex;
		flex-direction: column;
		// width: 100%;
		// border-radius: 12px;
		padding: 0 16px;
		background-color:#122A88;
		// background-position: left center;
		// background-size: cover;
		// background: #122A88 left center/cover;
		overflow: hidden;
		.preview_header {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			min-height: 110px;
			color: #fff;
			text-align: center;
			padding: 0 8px;
			.preview_header_text {
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				h1{
					font-size: 18px;
            		line-height: 42px;
				}
			}
			.preview_header_icon {
				background: rgba($color: #3A3A3A, $alpha: .4);
				border-radius: 6px;
				width: 34px;
				display:flex;
				align-items: center;
				justify-content: center;
				height: 34px;
				margin-top: -20px;
				
			}
		}
		// .preview_main {
		// 	flex: 1;
		// 	overflow-x: hidden;
		// 	overflow-y: auto;
		// 	box-sizing: border-box;
		// 	border-radius: 6px;
		// }
	}
}
</style>